import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-infraon-itsm-for-it-service-solution',
  imports: [RouterModule],
  templateUrl: './infraon-itsm-for-it-service-solution.html',
  styleUrl: './infraon-itsm-for-it-service-solution.scss',
})
export class InfraonITSMForItServiceSolution {

}
